export enum AdderType {
  overall = 'Overall',
  miso = 'MISO',
  ercot = 'ERCOT',
  isone = 'ISONE',
  nyiso = 'NYISO',
  pjm = 'PJM',
}
